// Geo-detection data for the landing page.
//
// This file also carried `T`, a 20-language translation table compiled into
// the bundle — 137 KB every visitor downloaded in order to use one language,
// and a second copy of strings that already live in
// `config/locales/frontend/<lang>/landing.yml`. The two drifted: `T` still
// said "165+ nozzle models" after the YAML was corrected to 202+, and because
// `setLanguage()` ran after hydration it overwrote the correct server-rendered
// text with the stale copy, in all 20 languages. The page is server-rendered
// and takes its language from the URL, so the table had no job left.



// Timezone-to-country mapping (~85% accuracy, free, no API needed)
const tzToCountry = {
  'Europe/Kyiv': 'UA', 'Europe/Kiev': 'UA', 'Europe/Uzhgorod': 'UA', 'Europe/Zaporozhye': 'UA',
  'America/New_York': 'US', 'America/Chicago': 'US', 'America/Denver': 'US', 'America/Los_Angeles': 'US',
  'America/Phoenix': 'US', 'America/Anchorage': 'US', 'Pacific/Honolulu': 'US',
  'Europe/London': 'GB', 'Europe/Berlin': 'DE', 'Europe/Paris': 'FR', 'Europe/Madrid': 'ES',
  'Europe/Rome': 'IT', 'Europe/Warsaw': 'PL', 'Europe/Lisbon': 'PT', 'Europe/Amsterdam': 'NL',
  'Europe/Brussels': 'BE', 'Europe/Vienna': 'AT', 'Europe/Zurich': 'CH', 'Europe/Stockholm': 'SE',
  'Europe/Prague': 'CZ', 'Europe/Budapest': 'HU', 'Europe/Bucharest': 'RO', 'Europe/Athens': 'GR',
  'Europe/Istanbul': 'TR', 'Asia/Jerusalem': 'IL', 'Asia/Tel_Aviv': 'IL',
  'Asia/Riyadh': 'SA', 'Asia/Dubai': 'AE', 'Africa/Cairo': 'EG',
  'America/Toronto': 'CA', 'America/Vancouver': 'CA', 'America/Montreal': 'CA',
  'America/Mexico_City': 'MX', 'America/Sao_Paulo': 'BR', 'America/Argentina/Buenos_Aires': 'AR',
  'America/Bogota': 'CO', 'America/Santiago': 'CL', 'America/Lima': 'PE',
  'Australia/Sydney': 'AU', 'Australia/Melbourne': 'AU', 'Australia/Perth': 'AU',
  'Pacific/Auckland': 'NZ', 'Asia/Tokyo': 'JP', 'Asia/Seoul': 'KR',
  'Asia/Shanghai': 'CN', 'Asia/Kolkata': 'IN', 'Africa/Johannesburg': 'ZA',
}

// Language-to-country fallback mapping
const langToCountry = {
  'uk': 'UA', 'en': 'US', 'en-US': 'US', 'en-GB': 'GB', 'de': 'DE',
  'pl': 'PL', 'fr': 'FR', 'pt-BR': 'BR', 'pt': 'PT', 'it': 'IT',
  'es': 'ES', 'ar': 'SA', 'tr': 'TR', 'he': 'IL', 'nl': 'NL',
  'el': 'GR', 'hu': 'HU', 'cs': 'CZ', 'ro': 'RO',
  'sk': 'SK', 'sv': 'SE', 'hr': 'HR', 'bg': 'BG'
}

export { tzToCountry, langToCountry };
